import React, { useMemo } from "react";
import Loader from "../components/Loader";
import InnerBannerBreadcrumb from "../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../redux/services/apiSlice";
import {
  convertSymbolCodes,
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../Utils/utils";
import PageLastUpdated from "../components/shared/PageLastUpdated";
import { useLocation } from "react-router-dom";
import useSeo from "../hooks/useSeo";

const ContactUsPage = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const { data: contactUsData = [], isLoading: contactUsIsLoading } =
    useGetProtectedApiDataQuery({ url: "contact_us", lang: languageType });

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(getLatestUpdatedObject(contactUsData)?.changed);
  }, [contactUsData]);

  const [corporateOffice, corporateAffairs] = contactUsData;

  const corporateOfficeAddress =
    corporateOffice?.field_corporate_affairs_address?.split(",");

  const corporateAffairsAddress =
    corporateAffairs?.field_corporate_affairs_address?.split(",");

  if (contactUsIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
        titleLink="/contact-us"
        levelTwo={false}
        levelThree={false}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 print-contact1">
                <div className="detail-box2 title-sec">
                  <h2>
                    {convertSymbolCodes(corporateOffice.field_corporate_type)}
                  </h2>
                  <ul>
                    <li>
                      <p className="heading">
                        <i className="fa fa-map-marker" aria-hidden="true">
                          &nbsp;
                        </i>
                        {getText(
                          "North Eastern Electric Power Corporation Ltd",
                          "नॉर्थ ईस्टर्न इलेक्ट्रिक पावर कॉर्पोरेशन लिमिटेड",
                        )}
                      </p>
                      {corporateOfficeAddress?.length > 0 && (
                        <div className="cont-lspace">
                          <p>{corporateOfficeAddress[0]},</p>
                          <p>{corporateOfficeAddress[1]},</p>
                          <p>
                            {corporateOfficeAddress[2]},{" "}
                            {corporateOfficeAddress[3]},{" "}
                            {corporateOfficeAddress[4]}
                          </p>
                        </div>
                      )}
                    </li>
                    <li>
                      <p>
                        <i className="fa fa-phone" aria-hidden="true"></i>
                        {getText("L/L:", "एल/एल:")}
                        {corporateOffice.field_corporate_affairs_phone} <br />
                        <i className="fa fa-fax" aria-hidden="true">
                          &nbsp;
                        </i>
                        {getText("Fax:", "फैक्स:")}{" "}
                        {corporateOffice?.field_corporate_affairs_fax}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 print-contact1">
                <iframe
                  src={corporateOffice.field_address_board_directoer}
                  width="100%"
                  height="210"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <hr className="cont-hr-brd" />
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 print-contact1">
                <iframe
                  src={corporateAffairs.field_address_board_directoer}
                  width="100%"
                  height="210"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 print-contact1">
                <div className="detail-box2 title-sec">
                  <h2>{corporateAffairs.field_corporate_type}</h2>

                  <ul>
                    <li>
                      <p className="heading">
                        <i className="fa fa-map-marker" aria-hidden="true">
                          &nbsp;
                        </i>
                        {getText(
                          "North Eastern Electric Power Corporation Ltd",
                          "नॉर्थ ईस्टर्न इलेक्ट्रिक पावर कॉर्पोरेशन लिमिटेड",
                        )}
                      </p>
                      {corporateAffairsAddress?.length > 0 && (
                        <div className="cont-lspace">
                          <p>
                            {corporateAffairsAddress[0]},{" "}
                            {corporateAffairsAddress[1]},
                          </p>
                          <p>{corporateAffairsAddress[2]}, </p>
                          <p>
                            {corporateAffairsAddress[3]},{" "}
                            {corporateAffairsAddress[4]}
                          </p>
                        </div>
                      )}
                    </li>
                    <li>
                      <p>
                        <i className="fa fa-phone" aria-hidden="true">
                          &nbsp;
                        </i>
                        {getText("Phone:", "टेलीफ़ोन:")}
                        {corporateAffairs.field_corporate_affairs_phone}
                        <br />
                        <i className="fa fa-envelope" aria-hidden="true"></i>
                        {getText("Email:", "ईमेल:")}{" "}
                        {corporateAffairs?.field_corporate_affairs_email}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUsPage;
